import { useQuery } from '@tanstack/react-query'
import { getJwt } from '@/shared/lib/betterAuth/get-jwt'
import { getPetBreeds } from '@/services/pets.services'
import {
  RENTERS_QUERY_KEYS,
  CACHE_STALE_TIME,
  CACHE_GC_TIME,
  QUERY_NETWORK_MODE,
} from '@/shared/constants/cache'
import type { PetBreed } from '@/shared/types/global.types'

export function usePetBreeds() {
  return useQuery<PetBreed[]>({
    queryKey: RENTERS_QUERY_KEYS.petBreeds,
    queryFn: async () => {
      const token = await getJwt()
      if (!token) throw new Error('No JWT token')
      return getPetBreeds(token)
    },
    staleTime: CACHE_STALE_TIME,
    gcTime: CACHE_GC_TIME,
    networkMode: QUERY_NETWORK_MODE,
  })
}
